
import Vue from "vue";
import sourcePreview from "components/SourcePreview.vue";
import {
  GetSourceInfo,
  GetSourceByTeaId,
  AddCourseScourse
} from "api/v1.design.courseware";
import { Message } from "element-ui";
import PreparingCourseware from "components/PreparingCourseware.vue";
import {
  GetSchoolCourseSourceTeaList,
  GetCourseBySchool
} from "api/v1.partner.source";
import { getSchoolCourseList } from "api/v1.manager.schoolCourseManage";
export default Vue.extend({
  name: "ToSchoolSource",
  components: {
    "source-preview": sourcePreview,
    PreparingCourseware
  },
  data() {
    return {
      files: [],
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: <any>[],
      nodePathList: <any>[],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      dataCount: 1,
      sourceIds: <any>[],
      sourceId: "",
      checks: <any>[],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      disabled: false,
      checkStatus: false,
      checkArr: <any>[],
      dialogVisiblePreviewResources: false,
      activeName: "source",
      schoolcourseList: <any>[],
      CreateUserId: "",
      IsTea: true,
      IsSource: false,
      IsPartner: 0,
      TeaAvatorUrlList: <any>[],
      keyIndex: -1,
      schoolList: <any>[],
      flag: 0,
      SchoolCourseTypeId: "",
      CourseList: <any>[],
      CourseId: "",
      coursetotalCount: 0,
      coursepagesize: 0,
      coursepageindex: 0,
      defaultCover: require("assets/images/noCover.jpg"), // 默认封面
      folderId: "",
      Title: "",
      MeShow:true,
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    activityIds: {},
    importfolderId: {
      type: String,
      default: "0"
    },
    IsState: {
      type: Number,
      default: 0
    },
    setData: {
      type: Object,
      default: []
    }
  },
  created() {
    // this.getSchoolCourseSourceTeaList();
    this.GetSchoolCourseList();
    this.getCourseBySchool(1);
  },
  watch: {
    Title(){
      this.getsearch();
      if(this.Title!=""){
        this.MeShow=false;
      }else{
        this.MeShow=true;
      }
    },
    sourceIds() {
      debugger;
      this.$emit("update:setData", this.sourceIds);
    },
    checkData(val) {
      let checkLength = this.list.length;
      for (let i = 0; i < checkLength; i++) {
        if (this.list[i].checked) {
          if (this.list[i].checked == true) {
            this.list[i].chec1ked = false;
          }
        }
      }
    }
  },
  methods: {
    getsearch() {
      this.getCourseBySchool(1);
    },
    GetSchoolCourseType(event: any, index: any) {
      this.sourceIds = [];
      this.folderId = "0";
      this.IsTea = true;
      this.IsSource = false;
      this.SchoolCourseTypeId = event;
      this.keyIndex = index;
      // this.getSchoolSource(1);
      // this.getSchoolCourseSourceTeaList();
      this.getCourseBySchool(1);
    },
    ///获取学校课程目录
    GetSchoolCourseList(page: any) {
      getSchoolCourseList(0,"", "", page).then(rst => {
        this.schoolcourseList = rst.schoolcourseList;
      });
    },
    ///点击学校老师头像
    ChageSchoolAvatorUrl() {
      this.IsPartner = 2;
      this.IsTea = false;
      this.IsSource = true;
      this.CreateUserId = "";
      this.getSchoolSource(1);
    },
    ///点击官方资源
    ChageAvatorUrl(createid: any, index: any) {
      this.IsPartner = 0;
      this.IsTea = false;
      this.IsSource = true;
      this.CreateUserId = createid;
      this.flag = index;
      this.getSchoolSource(1);
    },
    ///获取获取学校课程下所有老师
    getSchoolCourseSourceTeaList() {
      GetSchoolCourseSourceTeaList(this.SchoolCourseTypeId).then(rst => {
        this.TeaAvatorUrlList = rst.teaList;
      });
    },
    onAllChangeHandler() {
      this.sourceIds = [];
      this.folderId = "0";
      this.IsTea = true;
      this.IsSource = false;
      this.SchoolCourseTypeId = "";
      this.keyIndex = -1;
      // this.getSchoolSource(1);
      // this.getSchoolCourseSourceTeaList();
      this.getCourseBySchool(1);
    },
    ///关闭弹窗
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    ///获取学校资源
    getSchoolSource(page: any) {
      this.$nextTick(() => {
        GetSourceByTeaId(
          this.IsPartner,
          this.CreateUserId,
          this.folderId,
          page,
          this.SchoolCourseTypeId
        ).then(rst => {
          this.list = rst.list;
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.courseName = rst.courseName;
          this.nodePathList = rst.nodePathList;
          this.dataCount = rst.dataCount;
          console.log(this.list);
        });
      });
    },
    ///获取文件夹下的资源
    clickFolderHander(newFolderId: any) {
      this.folderId = newFolderId;
      let pageIndex = this.list.pageIndex;
      this.getSchoolSource(pageIndex);
    },
    ///预览图片
    previewImage(Id: string, url: string, type: string) {
      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }
        GetSourceInfo(Id).then(rst => {
          console.log(rst);
          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            this.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };
          }
        });
      }
    },
    ///分页
    onPageChangeHandler(page: number) {
      this.getSchoolSource(page);
    },
    ///选择课件
    handleSelectionChange(source: any) {
      let idx = this.sourceIds.indexOf(source.Id);
      let checked = source.checked;
      if (idx >= 0 && !checked) {
        this.sourceIds.splice(idx, 1);
      } else if (idx < 0 && checked) {
        this.sourceIds.push(source.Id);
      }
    },
    //导入课件
    importSource() {
      if (this.sourceIds.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        AddCourseScourse(
          this.sourceIds,
          this.courseId,
          this.importfolderId,
          this.CreatedSchoolId,
        ).then(rst => {
          if (rst.code > 0) {
            this.$emit("update:IsState", Math.random());
            this.$message.success(rst.msg);
          } else {
            this.$message({
              type: "warning",
              message: rst.msg
            });
          }
          let checkLength = this.list.length;
          for (let i = 0; i < checkLength; i++) {
            if (this.list[i].checked) {
              if (this.list[i].checked == true) {
                this.list[i].checked = false;
              }
            }
          }
          this.sourceIds = [];
          this.$emit("closeDialog", true);
        });
      }
      this.disabled = false;
      this.checkStatus = true;
    },
    getCourseBySchool(page: any) {
      GetCourseBySchool(this.SchoolCourseTypeId, this.Title, page).then(rst => {
        this.CourseList = rst.list;
        this.coursetotalCount = rst.pagination.totalCount;
        this.coursepagesize = rst.pagination.pageSize;
      });
    },
    onPageChangeCourseHandler(page: any) {
      debugger;
      this.getCourseBySchool(page);
    }
  }
});
